(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["medistik-gift-card-recipient"] && !Shopify.designMode) return;
  try {
    class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-gift-recipient-toggle]');
      this.fields = this.querySelector('[data-gift-recipient-fields]');
      this.offset = this.querySelector('[data-gift-recipient-offset]');
      this.message = this.querySelector('textarea[name="properties[Message]"]');
      this.count = this.querySelector('[data-gift-recipient-count]');

      /* Shopify schedules Send on against the shop timezone unless the
         customer's own offset comes along with it. */
      if (this.offset) this.offset.value = String(new Date().getTimezoneOffset());

      this.toggle?.addEventListener('change', this.#sync.bind(this));
      this.message?.addEventListener('input', this.#updateCount.bind(this));
      this.#sync();
    }

    /* A disabled fieldset submits none of its controls, which keeps empty
       recipient properties off ordinary gift card purchases. */
    #sync() {
      if (!this.fields) return;
      this.fields.disabled = !this.toggle?.checked;
    }

    #updateCount() {
      if (!this.count || !this.message) return;

      const remaining = this.message.maxLength - this.message.value.length;
      const template = this.count.dataset.template || this.count.textContent.trim();
      this.count.dataset.template = template;
      this.count.textContent = template.replace(/\d+/, String(remaining));
    }
  }

  if (!customElements.get('gift-card-recipient')) {
    customElements.define('gift-card-recipient', GiftCardRecipient);
  }
  } catch(e) { console.error(e); }
})();

})();
